import _ from 'lodash';
import * as api from './api';
import * as yup from 'yup';
import * as helpers from 'services/helpers';

export const fetchList = async (params = {}) => {
  try {
    let res = await api.fetchList(params);
    return res;
  } catch (err) {
    throw err;
  }
};

export const fetchDeliveriesByDealAndType = async (params = {}) => {
  try {
    let res = await api.fetchDeliveriesByDealAndType(params);
    return res;
  } catch (err) {
    throw err;
  }
};
